import { Base } from "../core/base.model";

export class UsuarioFise extends Base{
    public id: number;
    public usuario: string;
	public password: string;
	public tipo_usuario: string;
	public descripcion: string;
	public id_Servidor: number;
	public id_usuario_config: number;
	public id_Aplicacion: number
	public id_corporativo: number;
	public check: boolean = false;
}